var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warning_bar",class:[_vm.warning_bar_style_class, _vm.show_message ? 'show_warning_bar' : 'not_show_warning_bar']},[_vm._v(" "+_vm._s(_vm.message)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }